import { FC } from 'react'
import cn from './index.module.css'
import { ClassInfoType } from '@pages/Admin/ManageClassSettings/types'
import { Checkbox } from 'antd'
import cclasses from '@pages/Admin/CRM/styles/checkbox.module.css'
import classes from '../../index.module.css'
import classNames from 'classnames'
import LinkView from '@pages/Admin/CourseSettings/components/LinkView/LinkView'
import { useGetExtraPurchaseFields } from '@pages/Admin/PlatformSettings2/DirectorySettings/components/ExtraPurchaseFields/utils'

interface IClassDirectLink {
  classSettings: ClassInfoType
  onLinkShowChange: () => void
}

const ClassDirectLink: FC<IClassDirectLink> = ({
  classSettings,
  onLinkShowChange,
}) => {
  const { extraFields } = useGetExtraPurchaseFields()
  const extraParams = extraFields
    .map((field) => `${encodeURIComponent(field)}=`)
    .join('&')
  const classDirectLink = `${window.location.origin}/courses/all?class_id=${
    classSettings.id
  }${extraParams ? `&${extraParams}` : ''}`

  return (
    <div className={cn.wrapper}>
      <Checkbox
        className={classNames(cclasses.checkbox, classes.checkbox)}
        checked={classSettings.direct_link_enabled ?? false}
        onChange={onLinkShowChange}
      >
        Создать прямую ссылку для записи на класс
      </Checkbox>
      {classSettings.direct_link_enabled && <LinkView link={classDirectLink}/>}
    </div>
  )
}

export default ClassDirectLink
